import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { SupplierSaleItem } from '../SalesPage';

interface SalesExcelExportProps {
    data: SupplierSaleItem[];
    supplierName: string;
    onRef: (exporter: ExcelExport | null) => void;
}

export const SalesExcelExport: React.FC<SalesExcelExportProps> = ({ data, supplierName, onRef }) => {
    return (
        <ExcelExport
            data={data}
            ref={onRef}
            fileName={`${supplierName}_Sales_${new Date().toLocaleDateString()}`}
        >
            <ExcelExportColumn field="item_description" title="Item Description" width={250} />
            <ExcelExportColumn field="item_number" title="Item Number" />
            <ExcelExportColumn field="item_ndc" title="Item NDC" />
            {/* <ExcelExportColumn field="item_uom" title="Item UOM" /> */}
            <ExcelExportColumn field="account_name" title="Account Name" width={200} />
            <ExcelExportColumn field="account_number" title="Account Number" width={250} />
            <ExcelExportColumn field="purchase_order_number" title="PO Number" />
            <ExcelExportColumn field="purchase_order_date" title="PO Date" />
            <ExcelExportColumn field="invoice_date" title="Invoice Date" />
            <ExcelExportColumn field="invoice_number" title="Invoice Number" />
            <ExcelExportColumn field="invoice_quantity" title="Invoice Quantity" />
            <ExcelExportColumn field="item_unit_price" title="Item Price" />
            <ExcelExportColumn field="item_total_price" title="Total Sales" />
        </ExcelExport>
    );
}; 